import * as Preact from 'preact';
import { Box, CircularProgress, Typography } from '@mui/material';
export var Component = function (p) {
    return (Preact.h(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'background.default',
            width: '100%',
            height: '100%',
        } },
        Preact.h(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                height: '84px',
            } },
            Preact.h(CircularProgress, null),
            Preact.h(Typography, null, p.loadingText))));
};
